/* i18n-disable-file: 路由 meta.title 直接使用中文 key，消费方需在设置 document.title 时调 i18n.t(meta.title) 进行翻译 */
export default [
    {
      path: '/mng/rhino/download/index',
      name: 'profile',
      component: () => import('@/pages/mng/download/App.vue'),
      meta: {
        title: '下载中心',
      },
    },
  ];
